import { render, staticRenderFns } from "./GoodsTable.vue?vue&type=template&id=3ffc2d7d&scoped=true"
import script from "./GoodsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./GoodsTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GoodsTable.vue?vue&type=style&index=0&id=3ffc2d7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc2d7d",
  null
  
)

export default component.exports